<template>
	<Chart
		ref="ref__chart"
		:options="chartOptions"
		class="w-full h-fit"
	/>
</template>

<script>
import Highcharts from 'highcharts'
import { Chart } from 'highcharts-vue'
import i18n from '../../../../VueI18n'

export default {
	name: 'GraficoNivelPovoamentoEstrato',
	components: {
		Chart,
	},
	props: {
		data: { type: Array, required: true },
	},
	computed: {
		chartOptions() {
			return {
				/**
				 * Creditos no canto inferior direito do grafico
				 */
				credits: {
					enabled: false,
				},
				exporting: {
					enabled: false,
				},
				chart: {
					type: 'spline',
				},
				legend: {
					enabled: false,
					align: 'right',
					// layout: "proximate"
				},
				title: {
					text: '',
				},
				yAxis: {
					title: {
						text: this.$attrs.titleY,
					},
				},
				xAxis: {
					type: 'datetime', // Indica que o eixo X é do tipo datetime
					title: {
						text: i18n.t('measurementDate'),
					},
					labels: {
						formatter: function () {
							return Highcharts.dateFormat('%d/%m/%Y', this.value)
						},
					},
				},
				tooltip: {
					enabled: true,
				},
				accessibility: {
					point: {
						valueSuffix: '%',
					},
				},
				plotOptions: {},
				series: this.data,
				responsive: {
					rules: [
						{
							condition: {
								maxWidth: 500,
							},
							chartOptions: {
								series: [
									{
										size: '80%',
										innerSize: '90%',
									},
								],
							},
						},
					],
				},
			}
		},
	},
}
</script>

<style>
.highcharts-container {
	width: 100% !important;
	height: 100% !important;
}
</style>
